<portal-page design="col2">
  <section class="bg-light-gray" col1 data-hide-sm="true">
    <div class="svg-image">
      @if (!sendedRequest) {
        <portal-erfolg-1-svg />
      }
      @if (sendedRequest) {
        <portal-erfolg-2-svg [showCheckMark]="true" />
      }
    </div>
    <div class="fill-remaining-space">
      <h6 class="mat-h6">{{ 'reset_password.label.header' | translate }}</h6>
    </div>
  </section>

  <section class="bg-white" col2 data-col-width="66">
    @if (sendedRequest) {
      <div>
        <h4 class="mat-h4">{{ 'reset_password.label.success' | translate }}</h4>
        <ebeihilfe-note type="success" [messageText]="'reset_password.text.success' | translate" />
      </div>
    }

    @if (!sendedRequest) {
      <ebeihilfe-note type="danger" [messageText]="'reset_password.text.info' | translate" />
      <form
        (submit)="submitResetPasswordForm()"
        [attr.aria-label]="'a11y.form.reset_password' | translate"
        [formGroup]="resetPasswordForm">
        <portal-password-input
          autocomplete="new-password"
          formControlName="password"
          id="newpassword"
          [createPasswordMode]="true"
          label="{{ 'label.newPassword' | translate }}"
          hint="{{ 'info_text.input.set_password' | translate }}" />
        <portal-password-input
          [errors]="newPasswordRepeatErrors"
          autocomplete="new-password"
          id="repeatpassword"
          formControlName="passwordRepeat"
          [hint]="'info_text.input.passwordRepeat' | translate"
          [label]="'label.newPasswordRepeat' | translate"
          [placeholder]="'label.newPasswordRepeat' | translate" />
        <button [disabled]="resetPasswordForm.invalid" color="primary" mat-flat-button type="submit">
          {{ 'general.button.change' | translate }}
        </button>
      </form>
    }
  </section>
</portal-page>
